import { collection, addDoc, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export async function createTestData() {
  try {
    console.log('🚀 Creating test data...');
    
    // 1. Create a sample label schema
    const schemaId = `test_schema_${Date.now()}`;
    const schemaData = {
      name: 'Food Detection Test Schema',
      version: 1,
      scope: 'detection',
      classes: [
        { id: 'fresh', name: 'fresh', displayName: 'Fresh', description: 'Fresh food item', shapes: ['rectangle'] },
        { id: 'spoiled', name: 'spoiled', displayName: 'Spoiled', description: 'Spoiled food item', shapes: ['rectangle'] },
        { id: 'expired', name: 'expired', displayName: 'Expired', description: 'Expired food item', shapes: ['rectangle'] }
      ],
      guidelines: 'Classify the food item based on its condition',
      multi: false,
      createdAt: Date.now(),
      createdBy: 'test',
      updatedAt: Date.now(),
      updatedBy: 'test',
      archived: false
    };
    
    await setDoc(doc(db, 'labelSchemas', schemaId), schemaData);
    console.log('✅ Created schema:', schemaId);
    
    // 2. Create a schema version
    const versionData = {
      ...schemaData,
      _ref: { id: schemaId, version: 1 },
      _schemaHash: 'test_hash'
    };
    
    await setDoc(doc(db, 'labelSchemas', schemaId, 'versions', '1'), versionData);
    console.log('✅ Created schema version');
    
    // 3. Create a test task with schema attached
    const taskId = `test_task_${Date.now()}`;
    const taskData = {
      title: 'Test Food Classification Task',
      description: 'Test task for food classification',
      labelSchemaRef: { id: schemaId, version: '1' },
      requireQC: true,
      modelAssistEnabled: false,
      assignmentPolicy: 'manual',
      priorityDefault: 3,
      slaHours: 24,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(doc(db, 'tasks', taskId), taskData);
    console.log('✅ Created task:', taskId);
    
    // 4. Create test submissions
    const submissions = [];
    for (let i = 1; i <= 3; i++) {
      const submissionId = `test_submission_${Date.now()}_${i}`;
      const submissionData = {
        taskId: taskId,
        taskType: 'Photo',
        category: 'Food',
        taskTitle: 'Test Food Item',
        itemType: 'apple',
        imageUrl: `https://example.com/test_image_${i}.jpg`,
        mediaUrl: `https://example.com/test_image_${i}.jpg`,
        labels: null, // No labels yet
        status: 'approved',
        final: {
          status: 'approved',
          approvedAt: Date.now(),
          approvedBy: 'test'
        },
        createdAt: Date.now(),
        updatedAt: Date.now()
      };
      
      await setDoc(doc(db, 'submissions', submissionId), submissionData);
      submissions.push(submissionId);
      console.log(`✅ Created submission ${i}:`, submissionId);
    }
    
    // 5. Create labeling jobs for the submissions
    for (const submissionId of submissions) {
      const jobData = {
        submissionId: submissionId,
        taskId: taskId,
        schemaId: schemaId,
        mediaUrl: `https://example.com/test_image_${submissions.indexOf(submissionId) + 1}.jpg`,
        status: 'queued_human',
        assigneeId: null,
        qcReviewerId: null,
        labelsDraft: [],
        labelsFinal: [],
        reasons: [],
        labelSchemaSnapshot: versionData,
        assistUsed: false,
        priority: 3,
        dueAt: new Date(Date.now() + 24 * 3600 * 1000), // 24 hours from now
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      await addDoc(collection(db, 'labelingJobs'), jobData);
      console.log(`✅ Created labeling job for submission:`, submissionId);
    }
    
    console.log('🎉 Test data creation complete!');
    console.log('📋 Summary:');
    console.log(`   - Schema ID: ${schemaId}`);
    console.log(`   - Task ID: ${taskId}`);
    console.log(`   - Submissions: ${submissions.length}`);
    console.log(`   - Labeling Jobs: ${submissions.length}`);
    
    return {
      schemaId,
      taskId,
      submissions,
      success: true
    };
    
  } catch (error) {
    console.error('❌ Error creating test data:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : String(error)
    };
  }
}

// Make it available globally for testing
(window as any).createTestData = createTestData;


